module.exports = __webpack_public_path__ + "img/order.8ccc4566.svg";